import React from "react";
import {
  Background,
  Input,
  Button,
  Image,
  Form,
  ContactusColumn1,
  ContactusColumn2,
  ContacuspageRow,
  Subtitle
} from "./contactusComponents";
import mainImg from "../../assets/images/contactUs/girl3.svg";
import { ContactUsHeading } from "../../common/strings";

function App() {
  return (
    <div>
      <Background>
        <ContacuspageRow>
          <ContactusColumn1>
            <Form>
              <p>
                <h1><Subtitle>{ ContactUsHeading }</Subtitle></h1>
              </p>
              <p>Email address</p>
              <Input type="text" name="email" placeholder="123abc@gmail.com" />
              <p>Name</p>
              <Input name="pName" type="text" />
              <p>Message</p>
              <Input name="message" type="text" />
              <br />
              <br />
              <Button>Submit</Button>
              <br />
              <br />
            </Form>
          </ContactusColumn1>
          <ContactusColumn2>
            <Image src={mainImg} alt="Image" />
          </ContactusColumn2>
        </ContacuspageRow>
      </Background>
    </div>
  );
}

export default App;
